import { Fragment } from 'react';

import { profileApi } from '@pukka/api';
import { Alert } from '@pukka/ui-components';

import { CustomerDisplayAlertType } from './CustomerDisplayEditBox';
import { CustomerDisplayFormSchemaType } from './customerDisplayFormSchema';
import { getOutletName } from './utils';

const ALERT_PROPS: { [TYPE in CustomerDisplayAlertType]: { type: 'danger' | 'confirm'; title: string; okButtonName: string } } = {
  edit: {
    type: 'confirm',
    title: 'Changes confirmation',
    okButtonName: 'Save',
  },
  delete: {
    type: 'danger',
    title: 'Delete Campaign',
    okButtonName: 'Delete',
  },
  deactivate: {
    type: 'danger',
    title: 'Deactivate Campaign',
    okButtonName: 'Deactivate',
  },
  reactivate: {
    type: 'confirm',
    title: 'Reactivate Campaign',
    okButtonName: 'Reactivate',
  },
};

interface CustomerDisplayAlertProps {
  readonly campaign: CustomerDisplayFormSchemaType;
  readonly open: boolean;
  readonly variant: CustomerDisplayAlertType;
  readonly onConfirm: () => void;
  readonly onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
}

function getDescription(variant: CustomerDisplayAlertType, campaign: CustomerDisplayFormSchemaType) {
  const { data: profile } = profileApi.useProfile();

  if (variant === 'edit') {
    return (
      <>
        <span className="block py-4">
          Changes you make will also be applied to outlets listed below: <br />{' '}
        </span>
        <span className="block max-h-[94px] overflow-scroll">
          {campaign.outletIds.map((outletId) => (
            <Fragment key={outletId}>
              &nbsp; • {getOutletName(profile?.outlets || [], outletId)} <br />
            </Fragment>
          ))}
        </span>
      </>
    );
  }

  return (
    <span>
      Are you sure you want to {variant} <b>{campaign.name}</b>?
    </span>
  );
}

function CustomerDisplayAlert({ campaign, open, variant, onOpenChange, onConfirm }: CustomerDisplayAlertProps) {
  const alertProps = ALERT_PROPS[variant];

  return (
    <Alert {...alertProps} description={getDescription(variant, campaign)} open={open} onOpenChange={onOpenChange} onConfirm={onConfirm} />
  );
}

export default CustomerDisplayAlert;
